import React, { useState } from 'react'
import { Button, Card, Col, Form, Modal, Row } from 'react-bootstrap'
import closeIcon from "../../../Assets/images/colse-pdf.png"
import downIcon from "../../../Assets/images/down-arro.png"
import { useFormikContext } from 'formik'
import { PdfPeerForm, PdfPublishForm, userFullName } from 'helpers/common'
import AppInputField from 'components/shared/FormComponents/AppInputField'
import close from "Assets/images/cross_icon.png"
import ReportPDFDocViewer from './ViewReportPdf'

const ViewPdfModal = ({ show, setShow, doc, handleSubmit, guardianList, clientType, publishPdfCheckbox = false, isPopup = true, type = null }) => {
    const [showSubmitModal, setShowSubmitModal] = useState(false)
    const handleClose = () => setShow(false);

    return (
        <>
            <Modal
                className="pdf-viewer-class"
                fullscreen={true} show={show} onHide={handleClose}>
                <Modal.Header className='border-0 position-relative'>
                    <Modal.Title className='w-100'>
                        <div className='text-white d-flex align-items-center justify-content-end w-100' style={{ padding: "25px", gap: "100px" }}>
                            <button onClick={() => isPopup ? setShowSubmitModal(showSubmitModal ? !showSubmitModal : true) : handleSubmit()} className='discharge-screen  d-flex align-items-center gap-2'>SUBMIT & EXPORT <svg width="13" height="6" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.939684 1.3674L6.16086 6.18695C6.35239 6.36374 6.64761 6.36375 6.83914 6.18695L12.0603 1.3674C12.3948 1.05868 12.1763 0.500001 11.7212 0.500001L1.27883 0.5C0.82367 0.5 0.605235 1.05868 0.939684 1.3674Z" fill="white" />
                            </svg>
                            </button>
                            <img onClick={() => { setShowSubmitModal(false); handleClose(); }} style={{ cursor: "pointer" }} width={20} height={20} src={closeIcon} alt="closeIcon" />
                        </div>
                    </Modal.Title>
                    {
                        showSubmitModal &&
                        <div style={{ width: "379px", padding: "20px", backgroundColor: "white", position: "absolute", right: "80px", top: "87px", boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px" }}>
                            <div className="section-title d-flex align-items-center justify-content-between" style={{ borderColor: "#315D99" }}>
                                <h6 className="mb-0 section-title border-bottom-0" style={{ color: "#315D99" }}>{"SUBMIT & EXPORT"}</h6>
                                <img onClick={() => setShowSubmitModal(false)} width={16} height={16} src={close} alt="close" style={{ cursor: "pointer" }} />
                            </div>
                            {
                                guardianList?.length > 0 &&
                                <div className="section-title d-flex align-items-center justify-content-between" style={{ borderColor: "#315D99" }}>
                                    <h6 className="mb-0 section-title border-bottom-0" style={{ color: "#315D99" }}>{"EMAIL TO"}</h6>
                                </div>
                            }
                            {type === "peer" ? (
                                <PdfPeerForm publishPdfCheckbox={publishPdfCheckbox} setShowSubmitModal={setShowSubmitModal} guardianList={guardianList} clientType={"peer"} handleSubmit={handleSubmit} />
                            ):(
                                <PdfPublishForm publishPdfCheckbox={publishPdfCheckbox} setShowSubmitModal={setShowSubmitModal} guardianList={guardianList} clientType={clientType} handleSubmit={handleSubmit} />
                            )}
                        </div>
                    }
                </Modal.Header>
                {/* <Modal.Body> */}
                <ReportPDFDocViewer height='100%' showToolbar={false} doc={doc} />
                {/* </Modal.Body> */}
            </Modal >
        </>
    )
}

export default ViewPdfModal